export default __webpack_public_path__ + "static/christopher-carl-cdbf35fc40bf8996695714fcee749be9.webp";